// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const TrophyIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M5.75 13.95c-1.6-.06-1.41-2.36.16-2.22a1.1 1.1 0 0 1 .71-1.37v-.83c0-.52-.3-.98-.77-1.21a2.2 2.2 0 0 1-1.18-1.48L3.6 6.58c-.45-.11-.86-.37-1.14-.73Q2 5.3 2 4.6v-.56c0-.53.44-.96.98-.96h1.64v-.62c0-.22.19-.4.41-.4h5.94q.16 0 .29.12a.4.4 0 0 1 .12.28v.62h1.64c.54 0 .98.43.98.96v.56q0 .7-.45 1.26c-.28.36-.69.62-1.14.73l-1.08.26a2.2 2.2 0 0 1-1.18 1.48c-.47.22-.77.7-.77 1.2v.85c.56.2.88.79.72 1.36 1.56-.14 1.74 2.15.16 2.22zm0-1.42a.3.3 0 0 0-.22.1.3.3 0 0 0 0 .44q.1.08.23.07h4.49c.17 0 .3-.14.3-.3 0-.18-.14-.31-.3-.31zM7 11.1c-.17 0-.3.13-.31.3 0 .16.12.3.29.32h2.07a.3.3 0 0 0 .28-.33c-.01-.16-.14-.29-.3-.3zm.45-.8h1.12v-.78A2.1 2.1 0 0 1 9.8 7.6c.47-.23.77-.7.77-1.22V2.85H5.44v3.53c0 .52.3.99.77 1.22a2.2 2.2 0 0 1 1.23 1.93zM2.98 3.87a.16.16 0 0 0-.16.16v.56c0 .57.4 1.07.97 1.2l.83.2V3.88zm8.4 0V6l.84-.2c.56-.14.96-.64.96-1.21v-.56a.16.16 0 0 0-.16-.16z"
    />
  </svg>,
  "Trophy",
);
export default TrophyIcon;
